export default "__VITE_ASSET__BzqDEkZi__"